import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@veil/ui/components/sonner";
import { TooltipProvider } from "@veil/ui/components/tooltip";
import { NuqsAdapter } from "nuqs/adapters/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { ErrorBoundary } from "./components/error-boundary";
import { AuthProvider } from "./lib/auth-context";
import "./styles.css";

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
			retry: 1,
		},
	},
});

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("#root not found");

createRoot(rootEl).render(
	<StrictMode>
		<ErrorBoundary scope="Root">
			<NuqsAdapter>
				<QueryClientProvider client={queryClient}>
					<TooltipProvider delayDuration={150} skipDelayDuration={300}>
						<AuthProvider>
							<App />
							<Toaster richColors position="top-right" />
						</AuthProvider>
					</TooltipProvider>
				</QueryClientProvider>
			</NuqsAdapter>
		</ErrorBoundary>
	</StrictMode>,
);
